import controller from './recorder-ui.controller';
import template from './recorder-ui.html';
import './recorder-ui.scss';

export default {
	template,
	bindings: {},
	controller,
	controllerAs: '$ctrl',
};
